export default __webpack_public_path__ + "static/media/xm-white.ede1f0db.svg";